import {isNil} from 'ramda';

import {GetConsentTemplateMissingPlaceholdersApiArg, LegalForm} from '@dms/api/customer';
import {ConsentTemplate} from '@dms/api/shared';

import {isNotNilOrEmpty, Nullish} from 'shared/web';

import {getConsentContactPersonId} from './getConsentContactPersonId';
import {getConsentContactPersonRequirement} from './getConsentContactPersonRequirement';

interface ConsentTemplateMissingPlaceholdersInput {
  consentTypeId: string;
  template: ConsentTemplate | Nullish;
  customerId: string;
  customerContractInformationId: string | Nullish;
  legalForm: LegalForm | Nullish;
  contactPersonId: string | Nullish;
}

/**
 * Builds the missing-placeholders preview query for a ticked consent type, or null while the
 * form does not yet hold everything the preview needs (no template file, no contract
 * information, or a legal entity without its required contact person).
 */
export const getConsentTemplateMissingPlaceholdersArg = (
  input: ConsentTemplateMissingPlaceholdersInput
): GetConsentTemplateMissingPlaceholdersApiArg | null => {
  const template = input.template;
  const templateFileId = template?.fileId;
  const customerContractInformationId = input.customerContractInformationId;

  if (
    isNil(template) ||
    !isNotNilOrEmpty(templateFileId) ||
    !isNotNilOrEmpty(customerContractInformationId)
  ) {
    return null;
  }

  const contactPersonId = getConsentContactPersonId(input.legalForm, input.contactPersonId);

  if (
    getConsentContactPersonRequirement(input.legalForm) === 'required' &&
    isNil(contactPersonId)
  ) {
    return null;
  }

  return {
    consentTypeId: input.consentTypeId,
    templateTitle: template.title,
    templateFileId,
    customerId: input.customerId,
    customerContractInformationId,
    ...(isNil(contactPersonId) ? {} : {contactPersonId}),
  };
};
